export const ShiftScheduleEN = {
    "timeEngineSider": {
        "shiftRoster": "Shift schedule in month " ,
        "title" : "Roster " ,
        "to" : " to "
    },
    "timeEngineTitle": {
        "STT": "No.",
        "ID": "Employee ID",
        "fullName": "Full Name",
        "department": "Department",
        "jobPosition": "Job Position",
        "totalPoints": "Total Points",
        "points": "Point",
        "hour": "Hour",
        "standardPoints": "Standard points",
        "late": "Late",
        "minute": "Minute",
        "monetaryFine": "Monetary fine",
        "finePoints": "Fine points",
        "soon": "Leave soon",
        "forget": "Forget",
        "noReason": "Leave no reason",
        "leave": "Leave",
        "onLeave": "On leave",
        "first": "First term",
        "used": "Used",
        "last": "Last term",
        "moreHour": "More hour",
        "compensatoryLeave": "Compensatory leave",
        "mainPoints": "Main points",
        "workMore": "Work more",
        "shiftPoints": "Shift points",
        "holidayPoints": "Holiday points",
        "missionPoints": "Mission points",
        "nightWorkHour": "Night work hour",
        "holidayHour": "Holiday hour",
        "dayOffHour": "Day off hour",
        "shiftDayHour": "Shift day hour",
        "hourCount": "Hour count",
        "shiftCount": "Shift count",
        "shiftMore": "Shift more",
        "eatPoints": "Eat points",
        "nightHour": "Night hour",
        "totalAdd": "Total add"
    },
    "timeEngineDetail": {
        "noRecord" : "No records found",
        "shiftWork": "Shift work:",
        "shiftWorkName": "Shift work name:",
        "shiftWorkCode": "Shift work code:",
        "shiftWorkTime": "Time in/out:",
        "timeNotExist": "No",
        "date": "Date",
        "contextMenu": {
            "reCountPoints": "Re-count points and fine",
            "exportFile": "Export time keeping file",
            "updateFingerprint": "Update fingerprint"
        },
        MANUAL: "Manual",
        GPS: "GPS",
        APP: "Application",
        MACHINE: "Machine",
        recallSuccess: "Recall attendance success",
        header: "Timesheets"
    },
    "timeSheetHeader": {
        "header": "Monthly timesheet"
    }
}